<template>
  <div class="dropdown language_dropdown">
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
      right
    >
      <template #button-content>
        <img
          :src="getFlagUrl($i18n.locale)"
          :alt="$i18n.locale"
          class="mainFlag"
        />
      </template>

      <b-dropdown-item
        v-for="availableLocale in $i18n.availableLocales"
        :key="availableLocale"
        href="#"
        class="text-uppercase"
        @click="setI18nLanguage(availableLocale)"
      >
        <img
          :src="getFlagUrl(availableLocale)"
          :alt="availableLocale"
          class="flag mr-1"
        />
        {{ availableLocale }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "LanguageDropdown",
  methods: {
    setI18nLanguage(lang) {
      const redirect = new URL(window.location.href);
      const hostname = redirect.hostname;
      const lastIndex = hostname.lastIndexOf(".");

      const before = hostname.slice(0, lastIndex);

      redirect.hostname = before + "." + lang;

      // const localeHosts = process.env.VUE_APP_LOCALE_HOSTS.split(",");
      // const host =
      //     localeHosts[process.env.VUE_APP_LOCALES.split(",").indexOf(lang)];
      //
      // redirect.host = host;

      window.location.href = redirect.href;
    },

    getFlagUrl(code) {
      const publicPath = process.env.VUE_APP_PUBLIC_PATH
        ? process.env.VUE_APP_PUBLIC_PATH
        : "/";
      return publicPath + `images/flags/${code}.svg`;
    }
  }
};
</script>

<style lang="scss">
.language_dropdown {
  .dropdown-toggle::after {
    border: none;
  }
  .dropdown-toggle {
    line-height: 0;
  }
  .dropdown-menu {
    top: 1.25rem !important;
  }

  .dropdown__language {
    min-width: auto;
  }

  .flag {
    display: inline-block;
    font-size: 16px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    vertical-align: sub;
    text-align: center;
    border-radius: 3px;
    background-size: cover;
    background-position: center;
    margin-top: -12px;
  }

  .mainFlag {
    font-size: 16px;
    width: 20px;
    border-radius: 3px;
  }
}
</style>
